import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { deriveConfigurationWeldParams } from "../../helpers/common/ag-grid-helper";
import { logDataHelperFunctions } from "../../helpers/logdata-helper";
import { tiltViewHelper } from "../../helpers/tilt-view/tilt-view-helper";
import { GlobalUnitEnum } from "../../helpers/unit-conversion";
import { startTiltviewLoader } from "../../redux/TiltView/actions";
import { FETCH_TILTVIEW_SAGA } from "../../redux/TiltView/type";
import TiltViewGrid from "../AgGrid/Tilt-View";
import CommonLoader from "../Loaders/loader";

const TiltView = ({ weld_number }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();

  const selectedProjectId = useSelector(
    (state) => state?.projectReducer?.selectedProject?.project_id
  );
  const selectedProjectName = useSelector(
    (state) => state?.projectReducer?.selectedProject?.project_name
  );

  const { tiltviewList, isTiewviewLoding } = useSelector(
    (state) => state?.tiltviewReducer
  );

  const { projectReducer } = useSelector((state) => state);

  const [reportColumns, setReportColumns] = useState(
    logDataHelperFunctions.sampleReportColumns
  );

  // Extract global unit configuration from project details
  const globalUnit =
    projectReducer?.selectedProject?.globalUnit || GlobalUnitEnum.IMPERIAL;

  useEffect(() => {
    if (projectReducer?.selectedProject?.reportColumns) {
      try {
        let parsedData = JSON.parse(
          projectReducer?.selectedProject?.reportColumns
        );
        setReportColumns(parsedData);
      } catch (e) {
        console.log(e);
      }
    }
  }, [projectReducer?.selectedProject?.reportColumns]);

  useEffect(() => {
    const params = {
      project_id: selectedProjectId,
      project_name: selectedProjectName,
      weld_number: weld_number,
    };
    dispatch(startTiltviewLoader());
    dispatch({ type: FETCH_TILTVIEW_SAGA, payload: params });
  }, [dispatch, selectedProjectId, selectedProjectName, weld_number]);

  const transformData = (data) => {
    return data?.map((item, index) => {
      const { showRedCircle, hideStatus } = deriveConfigurationWeldParams({
        weldParams: projectReducer?.selectedProject?.weldParameters,
        view: "Tilt",
        jobNumbers: [item.jobNumber],
        statusCalculationMethod:
          projectReducer?.selectedProject?.statusCalculationMethod,
      });

      const transformedItem = {
        key: index,
        sl_no: index + 1,
        status: hideStatus ? "" : item.status,
        stationNumbers: item.stationName,
        buyType: item.bugType,
        type: item.additionalParams?.isM500 ? "" : item.torch,
        name: item.pass,
        tiltRange: item.tiltRange,
        // weldStartTime: item.weldStartTime,
        weldStartTime: logDataHelperFunctions.formatWeldStartTime(
          item?.unFormattedWeldStartTime,
          true
        ),
        weldStartTimeRaw: item?.unFormattedWeldStartTime,
        weld_time: item.weldTime,
        autoIncrement: item.autoIncrement || "-",
        current_low: showRedCircle
          ? item.current?.low
          : item?.current?.low?.toString().replace("-color", ""),
        current_avg: showRedCircle
          ? item.current?.avg
          : item?.current?.avg?.toString().replace("-color", ""),
        current_high: showRedCircle
          ? item.current?.high
          : item?.current?.high?.toString().replace("-color", ""),
        volt_low: showRedCircle
          ? item.volt?.low
          : item?.volt?.low?.toString().replace("-color", ""),
        volt_avg: showRedCircle
          ? item.volt?.avg
          : item?.volt?.avg?.toString().replace("-color", ""),
        volt_high: showRedCircle
          ? item.volt?.high
          : item?.volt?.high?.toString().replace("-color", ""),
        travel_speed_low: showRedCircle
          ? item.travelSpeed?.low
          : item?.travelSpeed?.low?.toString().replace("-color", ""),
        travel_speed_avg: showRedCircle
          ? item.travelSpeed?.avg
          : item?.travelSpeed?.avg?.toString().replace("-color", ""),
        travel_speed_high: showRedCircle
          ? item.travelSpeed?.high
          : item?.travelSpeed?.high?.toString().replace("-color", ""),
        true_energy_low: showRedCircle
          ? item.trueEnergy?.low
          : item?.trueEnergy?.low?.toString().replace("-color", ""),
        jobNumber: item?.jobNumber,
        true_energy_avg: showRedCircle
          ? item.trueEnergy?.avg
          : item?.trueEnergy?.avg?.toString().replace("-color", ""),
        true_energy_high: showRedCircle
          ? item.trueEnergy?.high
          : item?.trueEnergy?.high?.toString().replace("-color", ""),
        heat_low: showRedCircle
          ? item.heat?.low
          : item?.heat?.low?.toString().replace("-color", ""),
        heat_avg: showRedCircle
          ? item.heat?.avg
          : item?.heat?.avg?.toString().replace("-color", ""),
        heat_high: showRedCircle
          ? item.heat?.high
          : item?.heat?.high?.toString().replace("-color", ""),
        wire_speed_low: showRedCircle
          ? item.wireSpeed?.low
          : item?.wireSpeed?.low?.toString().replace("-color", ""),
        wire_speed_avg: showRedCircle
          ? item.wireSpeed?.avg
          : item?.wireSpeed?.avg?.toString().replace("-color", ""),
        wire_speed_high: showRedCircle
          ? item.wireSpeed?.high
          : item?.wireSpeed?.high?.toString().replace("-color", ""),
        oscillation_width_low: showRedCircle
          ? item.oscillationWidth?.low
          : item?.oscillationWidth?.low?.toString().replace("-color", ""),
        oscillation_width_avg: showRedCircle
          ? item.oscillationWidth?.avg
          : item?.oscillationWidth?.avg?.toString().replace("-color", ""),
        oscillation_width_high: showRedCircle
          ? item.oscillationWidth?.high
          : item?.oscillationWidth?.high?.toString().replace("-color", ""),
        frequency_low: showRedCircle
          ? item.frequency?.low
          : item?.frequency?.low?.toString().replace("-color", ""),
        frequency_avg: showRedCircle
          ? item.frequency?.avg
          : item?.frequency?.avg?.toString().replace("-color", ""),
        frequency_high: showRedCircle
          ? item.frequency?.high
          : item?.frequency?.high?.toString().replace("-color", ""),
        target_low: showRedCircle
          ? item.target?.low
          : item?.target?.low?.toString().replace("-color", ""),
        target_avg: showRedCircle
          ? item.target?.avg
          : item?.target?.avg?.toString().replace("-color", ""),
        target_high: showRedCircle
          ? item.target?.high
          : item?.target?.high?.toString().replace("-color", ""),
        horizontal_bias_low: showRedCircle
          ? item.horizontalBias?.low
          : item?.horizontalBias?.low?.toString().replace("-color", ""),
        horizontal_bias_avg: showRedCircle
          ? item.horizontalBias?.avg
          : item?.horizontalBias?.avg?.toString().replace("-color", ""),
        horizontal_bias_high: showRedCircle
          ? item.horizontalBias?.high
          : item?.horizontalBias?.high?.toString().replace("-color", ""),
        total_wire_consumed_low: showRedCircle
          ? item.totalWireConsumed?.low
          : item?.totalWireConsumed?.low?.toString().replace("-color", ""),
        total_wire_consumed_avg: showRedCircle
          ? item.totalWireConsumed?.avg
          : item?.totalWireConsumed?.avg?.toString().replace("-color", ""),
        total_wire_consumed_high: showRedCircle
          ? item.totalWireConsumed?.high
          : item?.totalWireConsumed?.high?.toString().replace("-color", ""),
        arcImpedance_low: showRedCircle
          ? item.arcImpedance?.low ?? ""
          : item?.arcImpedance?.low?.toString().replace("-color", ""),
        arcImpedance_avg: showRedCircle
          ? item.arcImpedance?.avg ?? ""
          : item?.arcImpedance?.avg?.toString().replace("-color", ""),
        arcImpedance_high: showRedCircle
          ? item.arcImpedance?.high ?? ""
          : item?.arcImpedance?.high?.toString().replace("-color", ""),
        additionalParams: {
          stationNumbers: item?.stationName,
          station_numbe: item?.stationName,
          buyType: item?.bugType,
          type: item?.torch,
          zone: "",
          s_deviceid_event: item?.additionalParams?.s_deviceid_event,
          weld_time: item?.weldTime,
          start_time: item?.unFormattedWeldStartTime,
          end_time: item?.additionalParams?.end_time,
          band_diameter: item?.additionalParams?.band_diameter,
          logging_distance: item?.additionalParams?.logging_distance,
          bug_number: item?.additionalParams?.bug_number,
          lead_wire_diameter: item?.additionalParams?.lead_wire_diameter,
          trail_wire_diameter: item?.additionalParams?.trail_wire_diameter,
          pipe_diameter: item?.additionalParams?.pipe_diameter,
          autoIncrement: item?.autoIncrement,
          gps: item?.additionalParams?.gps,
          iwm: item?.additionalParams?.iwm,
          tilt_start: item?.additionalParams?.tilt_start,
          tilt_end: item?.additionalParams?.tilt_end,
          isM500: item?.additionalParams?.isM500,
        },
      };

      // Apply unit conversion using the helper function
      return tiltViewHelper.mapperForUnitConversionTiltView(
        transformedItem,
        reportColumns,
        globalUnit
      );
    });
  };

  const handleRowClick = (record) => {
    const {
      stationNumbers = "",
      station_number = "",
      buyType = "",
      type = "",
      zone = "",
      s_deviceid_event = "",
      weld_time = "",
      start_time = "",
      end_time = "",
      band_diameter = "",
      logging_distance = "",
      bug_number = "",
      lead_wire_diameter = "",
      trail_wire_diameter = "",
      pipe_diameter = "",
      autoIncrement = "",
      gps = "",
      iwm = "",
      tilt_start = "",
      tilt_end = "",
      // eslint-disable-next-line no-unsafe-optional-chaining
      isM500 = false,
    } = record?.additionalParams;

    history.push("/tlog-data", {
      stationNumbers,
      station_number,
      buyType,
      type,
      zone,
      view: "Tilt",
      weld_number,
      s_deviceid_event: s_deviceid_event,
      weld_time,
      start_time,
      end_time,
      band_diameter,
      logging_distance,
      bug_number,
      lead_wire_diameter,
      trail_wire_diameter,
      pipe_diameter,
      autoIncrement,
      gps,
      iwm,
      tilt_start,
      tilt_end,
      isM500,
    });
  };

  const uniqueJobNumbers = [
    ...new Set(tiltviewList?.map((ite) => ite.jobNumber)),
  ];

  // Check if any items have isM500 true to determine if we should hide the type column
  const hasM500Items = tiltviewList?.some(
    (item) => item.additionalParams?.isM500
  );

  const { hideStatus } = deriveConfigurationWeldParams({
    weldParams: projectReducer?.selectedProject?.weldParameters,
    view: "Tilt",
    jobNumbers: uniqueJobNumbers,
    statusCalculationMethod:
      projectReducer?.selectedProject?.statusCalculationMethod,
  });

  return (
    <div className="w-full">
      {isTiewviewLoding ? (
        <div className="slogdata-loader">
          <CommonLoader />
        </div>
      ) : tiltviewList.length > 0 ? (
        <TiltViewGrid
          rows={transformData(tiltviewList)}
          reportColumns={reportColumns}
          isLoading={isTiewviewLoding}
          handleRowClick={handleRowClick}
          hideStatus={hideStatus}
          hideTypeColumn={hasM500Items}
        />
      ) : (
        <div className="slog-NoData">
          <p>{t("sLogData.noDataAvailable")}</p>
        </div>
      )}
    </div>
  );
};

export default TiltView;
